import * as AttributeActions from '../../../../state/attributes/attributes.action';

export default function TagDeleteModalController(
  $scope,
  $uibModalInstance,
  tag,
  $state,
  EquipmentService,
  gettextCatalog,
  $ngRedux,
) {
  'ngInject';
  $scope.tag = tag;
  $scope.loading = false;
  $scope.errorFlag = false;
  $scope.errorText = '';

  function dispatchRemove() {
    $ngRedux.dispatch(AttributeActions.removeAttribute());
  }

  $scope.ok = function () {
    $scope.errorFlag = false;
    $scope.loading = true;
    EquipmentService.deleteTag($scope.tag.id).then(
      () => {
        $uibModalInstance.close();
        $state.go('admin.tag-list');
        dispatchRemove();
      },
      (error) => {
        $scope.loading = false;
        let errorMsg = gettextCatalog.getString('An error occurred while deleting the attribute');
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg = `${
              error.data.message
            } ${error.status.toString()} - ${error.statusText.toString()}`;
          } else {
            errorMsg += `: ${error.status.toString()} - ${error.statusText.toString()}`;
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.errorFlag = true;
        $scope.errorText = errorMsg;
      },
    );
  };

  $scope.cancel = () => {
    $uibModalInstance.close();
  };

  $scope.$on('$locationChangeStart', (event) => {
    $scope.cancel();
  });
}
